import { Box } from '@mui/material'
import React from 'react'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import PageHeader from '../../components/PageHeader'
import { EmailFeature } from '../../features/EmailFeature'

const EmailPage: React.FC = (): JSX.Element => {
  return (
    <Box sx= {{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <CustomHeader title={PAGE_TITLES.EMAIL} />
      <PageHeader
        title={PAGE_TITLES.EMAIL}
        description='Track outbound email delivery for students, instructors, and admins.'
      />
      <EmailFeature />
    </Box>
  )
}

export default EmailPage
